import React, { CSSProperties } from 'react';
import { Modal, ModalProps } from 'antd';

/**
 * Custom Modal wrapper with enhanced styling
 */
export interface MyModalProps extends ModalProps {
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
  rounded?: boolean;
  blur?: boolean;
}

const MyModal: React.FC<MyModalProps> = ({
  variant = 'default',
  rounded = true,
  blur = false,
  style,
  className,
  children,
  ...rest
}) => {
  // Variant colors
  const variantColors: Record<string, string> = {
    default: '#1890ff',
    success: '#52c41a',
    warning: '#faad14',
    error: '#ff4d4f',
    info: '#1890ff',
  };

  const customStyle: CSSProperties = {
    borderRadius: rounded ? '12px' : '2px',
    overflow: 'hidden',
    ...style,
  };

  const bodyStyle: CSSProperties = {
    padding: '24px',
  };

  const maskStyle: CSSProperties = blur
    ? {
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(0, 0, 0, 0.45)',
      }
    : {};

  return (
    <Modal
      style={customStyle}
      bodyStyle={bodyStyle}
      maskStyle={maskStyle}
      className={className}
      centered
      {...rest}
    >
      {children}
    </Modal>
  );
};

export default MyModal;
